import axios from "axios";
import { installFeedback } from "@/lib/feedback";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api/v1`;

export const api = axios.create({ baseURL: API_BASE });

const TOKEN_KEY = "dpr_token";

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    delete api.defaults.headers.common.Authorization;
    localStorage.removeItem(TOKEN_KEY);
  }
}

// The branch chosen in the top bar. Sent with every request, so lists show only that branch and new records join it.
export const BRANCH_KEY = "erp_selected_branch_id";

api.interceptors.request.use((config) => {
  const branch = localStorage.getItem(BRANCH_KEY);
  if (branch) config.headers["X-Branch-Id"] = branch;
  return config;
});

// A branch saved in this browser that the server no longer knows (another database, a deleted branch): forget it and ask again once,
// before any error is shown. Registered before the feedback toasts so the person never sees the first failure.
const STALE_BRANCH = /branch (doesn't exist in your organisation|isn't valid)/i;
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const cfg = error?.config;
    const detail = error?.response?.data?.detail;
    const sent = cfg?.headers && (cfg.headers["X-Branch-Id"] || (typeof cfg.headers.get === "function" && cfg.headers.get("X-Branch-Id")));
    if (error?.response?.status === 400 && cfg && !cfg._branchRetried && sent && typeof detail === "string" && STALE_BRANCH.test(detail)) {
      localStorage.removeItem(BRANCH_KEY);
      cfg._branchRetried = true;
      if (typeof cfg.headers.delete === "function") cfg.headers.delete("X-Branch-Id");
      delete cfg.headers["X-Branch-Id"];
      return api(cfg);
    }
    return Promise.reject(error);
  }
);

installFeedback(api);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      setAuthToken(null);
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);
